module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nmodel.meta = model.meta || {}\nconst metaTitle = (model.meta.title || model.name || model.nameSEO || storage.__(\"error:unknownPageTitle\")) + ' | Livecom'\nconst assetFileTS = model.upStartTimestamp || '-'\nconst route = storage.request.route || {}\nconst routeConfig = route.config || {}\nconst routeHasLightbox = routeConfig.useLightBoxInFrontend === true\nconst routeLoadFECClientLibs = route.isAppPart === true\nconst bodyAttributes = ['']\nconst bodyClasses = utils.environment.getBodyClasses(environment)\nif(routeConfig.forceBodyClass){\nbodyClasses.push(routeConfig.forceBodyClass)\n}\nif(bodyClasses.length > 0){\nbodyAttributes.push(`class=\"${bodyClasses.join(' ')}\"`)\n}\n%><!doctype html>\n<html lang=\"<%= model.lang %>\">\n<head>\n<title><%= metaTitle %></title>\n<meta charset=\"utf-8\">\n<meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n<meta name=\"title\" content=\"<%= metaTitle %>\">\n<meta name=\"keywords\" content=\"<%= model.meta.keywords || '' %>\">\n<meta name=\"description\" content=\"<%= model.meta.description || '' %>\">\n<%- include('./meta'); %>\n<%- helpers.renderAlternateLinkMetaTags() %>\n<link rel=\"canonical\" href=\"https://www.livecom.at<%- route.path %>\" />\n<!--\t<link rel=\"stylesheet\" href=\"/dist/css/vendors~bundle~fec.css?usTS=<%- assetFileTS %>\">-->\n<link rel=\"stylesheet\" href=\"/dist-opt/shariff-3.2.1/shariff.min.css\">\n<link rel=\"stylesheet\" href=\"/dist-opt/photoswipe-4.1.3/bundle.min.css\">\n<%\nif (routeLoadFECClientLibs){\n%><link rel=\"stylesheet\" href=\"/dist/css/fec.css?usTS=<%- assetFileTS %>\"><%\n}\n%>\n<link rel=\"stylesheet\" href=\"/dist/css/bundle.css?usTS=<%- assetFileTS %>\">\n</head>\n<body<%- bodyAttributes.join(' ') %>>\n<div class=\"cookie-policy-bar\">\n<%-storage.__('common:cookiePolicyBar.text')%> <button type=\"button\">OK</button>\n</div>\n<header class=\"fixed-top\">\n<%- helpers.renderSection('header',false); %>\n</header>\n<main>\n<%- helpers.renderSection('content',false); %>\n</main>\n<footer>\n<%- helpers.renderSection('footer',false); %>\n</footer>\n<%\nif (routeLoadFECClientLibs){\n%>\n<!-- js server sources -->\n<script type=\"application/javascript\" class=\"dynamicJSSources\">\nglobalThis.fullRoute \t\t    = \"<%= model.fullRoute || '' %>\";\nglobalThis.route \t\t\t\t= \"<%= model.route || '' %>\";\nglobalThis.tree \t\t\t\t= <%- model.tree || 'null' %>;\nglobalThis.globalActionsByScope = <%- model.globalActionsByScope || 'null' %>;\nglobalThis.updateClientStorage \t= <%- model.updateClientStorage || 'null' %>;\n</script>\n<%\n}\n%>\n<script src=\"/dist/js/vendors~bundle~fec.js?usTS=<%- assetFileTS %>\"></script>\n<%\nif (routeLoadFECClientLibs){\n%><script src=\"/dist/js/fec.js?usTS=<%- assetFileTS %>\"></script><%\n}\n%>\n<script src=\"/dist-opt/photoswipe-4.1.3/bundle.min.js\"></script>\n<script src=\"/dist/js/bundle.js?usTS=<%- assetFileTS %>\"></script>\n<script src=\"/dist-opt/shariff-3.2.1/shariff.min.js\"></script>\n<% if (storage.app.service.config.isPRODEnvironment) { %>\n<% } %>\n</body>\n</html>"
  , __filename = "components\\layouts\\master\\master.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
model.meta = model.meta || {}
const metaTitle = (model.meta.title || model.name || model.nameSEO || storage.__("error:unknownPageTitle")) + ' | Livecom'
const assetFileTS = model.upStartTimestamp || '-'
const route = storage.request.route || {}
const routeConfig = route.config || {}
const routeHasLightbox = routeConfig.useLightBoxInFrontend === true
const routeLoadFECClientLibs = route.isAppPart === true
const bodyAttributes = ['']
const bodyClasses = utils.environment.getBodyClasses(environment)
if(routeConfig.forceBodyClass){
bodyClasses.push(routeConfig.forceBodyClass)
}
if(bodyClasses.length > 0){
bodyAttributes.push(`class="${bodyClasses.join(' ')}"`)
}

    ; __line = 17
    ; __append("<!doctype html>\n<html lang=\"")
    ; __line = 18
    ; __append(escapeFn( model.lang ))
    ; __append("\">\n<head>\n<title>")
    ; __line = 20
    ; __append(escapeFn( metaTitle ))
    ; __append("</title>\n<meta charset=\"utf-8\">\n<meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n<meta name=\"title\" content=\"")
    ; __line = 23
    ; __append(escapeFn( metaTitle ))
    ; __append("\">\n<meta name=\"keywords\" content=\"")
    ; __line = 24
    ; __append(escapeFn( model.meta.keywords || '' ))
    ; __append("\">\n<meta name=\"description\" content=\"")
    ; __line = 25
    ; __append(escapeFn( model.meta.description || '' ))
    ; __append("\">\n")
    ; __line = 26
    ; __append( include('./meta') )
    ; __append("\n")
    ; __line = 27
    ; __append( helpers.renderAlternateLinkMetaTags() )
    ; __append("\n<link rel=\"canonical\" href=\"https://www.livecom.at")
    ; __line = 28
    ; __append( route.path )
    ; __append("\" />\n<!--	<link rel=\"stylesheet\" href=\"/dist/css/vendors~bundle~fec.css?usTS=")
    ; __line = 29
    ; __append( assetFileTS )
    ; __append("\">-->\n<link rel=\"stylesheet\" href=\"/dist-opt/shariff-3.2.1/shariff.min.css\">\n<link rel=\"stylesheet\" href=\"/dist-opt/photoswipe-4.1.3/bundle.min.css\">\n")
    ; __line = 32
    ; 
if (routeLoadFECClientLibs){

    ; __line = 34
    ; __append("<link rel=\"stylesheet\" href=\"/dist/css/fec.css?usTS=")
    ; __append( assetFileTS )
    ; __append("\">")
    ; 
}

    ; __line = 36
    ; __append("\n<link rel=\"stylesheet\" href=\"/dist/css/bundle.css?usTS=")
    ; __line = 37
    ; __append( assetFileTS )
    ; __append("\">\n</head>\n<body")
    ; __line = 39
    ; __append( bodyAttributes.join(' ') )
    ; __append(">\n<div class=\"cookie-policy-bar\">\n")
    ; __line = 41
    ; __append(storage.__('common:cookiePolicyBar.text'))
    ; __append(" <button type=\"button\">OK</button>\n</div>\n<header class=\"fixed-top\">\n")
    ; __line = 44
    ; __append( helpers.renderSection('header',false) )
    ; __append("\n</header>\n<main>\n")
    ; __line = 47
    ; __append( helpers.renderSection('content',false) )
    ; __append("\n</main>\n<footer>\n")
    ; __line = 50
    ; __append( helpers.renderSection('footer',false) )
    ; __append("\n</footer>\n")
    ; __line = 52
    ; 
if (routeLoadFECClientLibs){

    ; __line = 54
    ; __append("\n<!-- js server sources -->\n<script type=\"application/javascript\" class=\"dynamicJSSources\">\nglobalThis.fullRoute 		    = \"")
    ; __line = 57
    ; __append(escapeFn( model.fullRoute || '' ))
    ; __append("\";\nglobalThis.route 				= \"")
    ; __line = 58
    ; __append(escapeFn( model.route || '' ))
    ; __append("\";\nglobalThis.tree 				= ")
    ; __line = 59
    ; __append( model.tree || 'null' )
    ; __append(";\nglobalThis.globalActionsByScope = ")
    ; __line = 60
    ; __append( model.globalActionsByScope || 'null' )
    ; __append(";\nglobalThis.updateClientStorage 	= ")
    ; __line = 61
    ; __append( model.updateClientStorage || 'null' )
    ; __append(";\n</script>\n")
    ; __line = 63
    ; 
}

    ; __line = 65
    ; __append("\n<script src=\"/dist/js/vendors~bundle~fec.js?usTS=")
    ; __line = 66
    ; __append( assetFileTS )
    ; __append("\"></script>\n")
    ; __line = 67
    ; 
if (routeLoadFECClientLibs){

    ; __line = 69
    ; __append("<script src=\"/dist/js/fec.js?usTS=")
    ; __append( assetFileTS )
    ; __append("\"></script>")
    ; 
}

    ; __line = 71
    ; __append("\n<script src=\"/dist-opt/photoswipe-4.1.3/bundle.min.js\"></script>\n<script src=\"/dist/js/bundle.js?usTS=")
    ; __line = 73
    ; __append( assetFileTS )
    ; __append("\"></script>\n<script src=\"/dist-opt/shariff-3.2.1/shariff.min.js\"></script>\n")
    ; __line = 75
    ;  if (storage.app.service.config.isPRODEnvironment) { 
    ; __append("\n")
    ; __line = 76
    ;  } 
    ; __append("\n</body>\n</html>")
    ; __line = 78
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components\layouts\master\master.ejs

}